import { CtaBanner } from '@/components/common/CtaBanner'

export function CtaBannerSection() {
  return (
    <CtaBanner
      title="Ready to Build Something That Stands Above?"
      description="Whether you need custom internal software, a customer-facing product, or an architecture consultation — let us discuss your specifications."
      ctaText="Initiate Project Inquiry"
      ctaHref="/contact"
      cardSurface="2"
      maxWidth="max-w-4xl"
    />
  )
}
